module.exports = __webpack_public_path__ + "static/media/background-cityoo.520527d1.svg";